const prefix = 'error-boundary';

export const i18n = {
    message: {
        id: `${prefix}.message`,
        defaultMessage: 'Something has gone wrong.',
    },
    details: {
        id: `${prefix}.details`,
        defaultMessage:
            'This has been logged and we will investigate what happened. Please refresh your browser to continue.',
    },
} as const;
